'use strict';

module.exports = '3.35.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 577
// module chunks = 142807904292071